import cn from "classnames"
import React from "react"
import { Trans, useTranslation } from "react-i18next"

import { Quote } from "~/api/types/QuotesList"
import { formatDate, isToday, isYesterday, parseDateTime } from "~/helpers/formatDate"

import { Heading } from "../Heading/Heading"
import { useThemeContext } from "../Theme/Theme"
import styles from "./index.module.css"

type QuotationProps = Quote & {
  className?: string
}

export const Quotation: React.FC<QuotationProps> = ({
  className,
  quote,
  stockMarket,
  change,
  price,
  update,
}) => {
  const changeUp = change.search("\\+") !== 0
  const { theme } = useThemeContext()
  const { t } = useTranslation()
  const updatedToday = isToday(parseDateTime(update))
  const updatedTomorrow = isYesterday(parseDateTime(update))

  const updateTime = formatDate(parseDateTime(update), {
    year: undefined,
    day: undefined,
    month: undefined,
    hour: "2-digit",
    minute: "2-digit",
  })

  let updateDate = formatDate(update, { year: "2-digit", month: "numeric" })

  if (updatedToday) {
    updateDate = ""
  }

  if (updatedTomorrow) {
    updateDate = t("Quotation.yesterday")
  }

  const StockMarketClassName = cn(styles.StockMarket, {
    [styles.StockMarketOnDark]: theme === "dark",
    [styles.StockMarketOnLight]: theme === "light",
  })

  return (
    <div className={cn(styles.Item, className)}>
      <div className={styles.Name}>{quote}</div>

      <div>
        <Heading as="div" className={styles.Price} like="h3">
          {price}
        </Heading>

        <div className={changeUp ? styles.ChangeDown : styles.ChangeUp}>{change}</div>

        <div className={StockMarketClassName}>{stockMarket}</div>

        <div className={styles.Update}>
          <Trans i18nKey="Quotation.Update" values={{ updateDate, updateTime }} />
        </div>
      </div>
    </div>
  )
}
